module.exports = __webpack_public_path__ + "img/truck.c2ba3ab4.png";